



const copyToClipBoard = (text: string) => {
  navigator.clipboard.writeText(text).then(() => null);
}

export default copyToClipBoard;